import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="nota-media"
// La nota media del formulario de review (`opinables/reviews/_form`), al día mientras se escriben
// las cuatro notas. La que se guarda la calcula el modelo (`Review#calcula_valoracion_media`) con la
// misma regla: la media de las cuatro, y una vacía cuenta como 0.
export default class extends Controller {
  static targets = ['nota', 'media']

  connect () {
    this.actualiza()
  }

  actualiza () {
    // Sin ninguna nota, el modelo no la toca: tampoco aquí.
    if (this.notaTargets.every(nota => nota.value === '')) return

    const suma = this.notaTargets.reduce((total, nota) => total + (Number(nota.value) || 0), 0)
    this.mediaTarget.value = suma / this.notaTargets.length
  }
}
